import { SpinLoader } from '@/components/loader/spin-loader';

export function GameLoading() {
    return (
        <div className="w-full h-full flex items-center justify-center">
            <SpinLoader className="w-8 h-8" />
        </div>
    );
}
